/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, November 12th 2021, 1:18:56 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { schemaBuilder } from "lib/validation";
import {
  ProcessTemplateArtifact,
  ProcessTemplateArtifactSchemaType,
  ProcessTemplateArtifactValidationSchema,
  DatasetSchema,
  FormField,
  TaskTemplate,
} from "lib/schemas";
import { QueryParameters } from "lib/types";
import { WritableModel } from "lib/schemas/abstract";

export interface DatasetReference extends ProcessTemplateArtifact, WritableModel<false> {
  name: string;
  readonly identifier?: string;
  readonly is_global?: boolean;
  ref_metadata: Refmetadata;
}

type Refmetadata = any; //JSONDatasetReadMetadata | JSONDatasetWriteMetadata | DBTableDatasetReadMetadata;

// For now, we are not supporting referencing of db tables from the Onestop admin client for security reasons. Only
// JSON datasets are supported.

export interface DBTableDatasetReadMetadata {
  fk: string;
  pk: string;
  table_name: string;
  label_field: string;
  value_field: string;
  related_field: string;
  related_table: string;
}

export interface JSONDatasetReadMetadata {
  pk: string;
  json_dataset_schema: DatasetSchema["id"];
  label_field: string;
  value_field: string;
}

export interface JSONDatasetWriteMetadata {
  json_dataset_schema: DatasetSchema["id"];
  data_mapping: { [target_field_key: string]: DataMapSourceMetadata };
}

export interface DataMapSourceMetadata {
  source_field_guid: FormField["artifact_guid"];
  source_field_data_key?: string;
  task_identifier?: TaskTemplate["identifier"];
}

export const DatasetReferenceValidationSchema: ProcessTemplateArtifactSchemaType<
  Omit<DatasetReference, "id" | "identifier" | "is_global">
> = ProcessTemplateArtifactValidationSchema.shape({
  name: schemaBuilder.string().required("Name is required"),
  ref_metadata: schemaBuilder.mixed().required("metadata is required"),
});

export type DatasetReferenceAPIFilters = QueryParameters<DatasetReference> & {
  reference_type?: "read" | "update";
};
